<template>
    <div>
        <!-- Escalate invoice/contract modals -->
        <InvoiceEscalateModals
            ref="InvoiceEscalateModals"
            :showEscalation="showEscalation"
            :showOutEscalation="showOutEscalation"
        />

        <b-table
            :data="records"
            :striped="true"
            :loading="loading"
            :mobile-cards="true"

            backend-pagination
            :total="total"
            :per-page="perPage"
            @page-change="onPageChange"
            backend-sorting
            :default-sort-direction="sortOrder"
            :default-sort="[sortField, sortOrder]"
            @sort="onSort"
            class="contractstable"

            :paginated="paginated"
            :sort-icon="'chevron-up'"
        >
            <template>
                <b-table-column v-slot="props" field="organisation" label="Org." width="50" :visible="user && user.role == 'pit' && $store.state.dataBelongsTo === 'all'" class="admin">
                    <b-button type="is-primary" outlined tag="router-link" size="is-small" :to="{ name: 'OrganisationsRecord', params: {id: props.row.organisation} }" v-if="user && user.role == 'pit'">
                        {{ _.has(organisations, props.row.organisation) ? organisations[props.row.organisation].short_name : '-' }}
                    </b-button>
                </b-table-column>

                <b-table-column v-slot="props" field="customer.type" label="Type" sortable>
                    <span v-if="hideSensitiveData">********</span>
                    <span v-else>
                        {{ props.row.customer.type == 'normal' ? 'Particulier' : props.row.customer.type == 'business' ? 'Zakelijk' : props.row.customer.type == 'foundation' ? 'Stichting' : props.row.customer.type }}
                    </span>
                </b-table-column>

                <b-table-column v-slot="props" field="customer" label="Klant" sortable>
                    <b-button tag="router-link" type="is-text" size="is-small" class="text-left" :to="{ name: 'CustomersRecord', params: {id: props.row.customer.id} }" v-if="props.row.customer">
                        <span v-if="hideSensitiveData">********</span>
                        <span v-else>
                            {{ props.row.customer.firstname }}&nbsp;{{ props.row.customer.lastname }}
                            <span v-if="!_.isNull(props.row.customer.companyname) && (props.row.customer.type == 'business' || props.row.customer.type == 'foundation')" :icon="!_.isNull(props.row.customer.companyname) && (props.row.customer.type == 'business' || props.row.customer.type == 'foundation') ? 'building' : 'people'">
                                <br>
                                <strong>
                                    <span v-if="props.row.customer.companyname.length >= 27">
                                        <b-tooltip :label="props.row.customer.companyname" position="is-top">
                                            {{ props.row.customer.companyname|truncate(25, '..') }}
                                        </b-tooltip>
                                    </span>
                                    <span v-else>{{ props.row.customer.companyname }}</span>
                                </strong>
                            </span>
                        </span>
                    </b-button>
                    <span v-else>-</span>
                </b-table-column>

                <b-table-column v-slot="props" field="payment_type" label="Betaalmethode" sortable>
                    <span>{{ props.row.payment_type == 'incasso' ? 'Incasso' : props.row.payment_type == 'manual' ? 'Handmatig' : props.row.payment_type }}</span>
                </b-table-column>

                <b-table-column v-slot="props" field="finalized" label="Status" width="130" sortable>
                    <b-tag :type="props.row.finalized == 0 ? 'is-success' : 'is-warning'">{{ props.row.finalized == 0 ? 'Actief' : 'Afgerond' }}</b-tag>
                    <router-link :to="{ name: 'ContractsRecordView', params: {id: props.row.id} }">
                        <b-icon icon="exclamation-circle" size="is-small" type="is-danger" v-show="props.row.confirm_stop == 1" />
                    </router-link>
                </b-table-column>

                <b-table-column v-slot="props" field="start_date" label="Start" width="120" sortable>
                    <span>{{ props.row.start_date|humanDate }}</span>
                </b-table-column>
                <b-table-column v-slot="props" field="end_date" label="Eind" width="120" sortable>
                    <span v-if="!_.isNull(props.row.end_date)">{{ props.row.end_date|humanDate }}</span>
                    <span v-else>-</span>
                </b-table-column>

                <b-table-column v-slot="props" field="access" label="Toegang" width="80" sortable :visible="user.role == 'pit' || user.organisation_connect">
                    <b-tooltip :label="!_.isNull(props.row.access.date_to) && moment(props.row.access.date_to).format('YMMDD') > moment(new Date()).format('YMMDD') || _.isNull(props.row.access.date_to) ? 'Actief' : 'Verlopen'" v-if="props.row.access">
                        <router-link :to="{ name: 'ConnectRecord', params: {id: props.row.access.id} }">
                            <b-button :type="!_.isNull(props.row.access.date_to) && moment(props.row.access.date_to).format('YMMDD') > moment(new Date()).format('YMMDD') || _.isNull(props.row.access.date_to) ? 'is-success' : 'is-danger'" icon-right="key" size="is-small" />
                        </router-link>
                    </b-tooltip>

                    <b-tooltip label="Toegang aanmaken" v-else>
                        <router-link :to="{ name: 'ConnectRecord', params: {id: 'nieuw'}, query: {customer: props.row.customer.id, contract: props.row.id} }">
                            <b-button type="is-light" size="is-small" icon-right="key" />
                        </router-link>
                    </b-tooltip>
                </b-table-column>

                <b-table-column v-slot="props" numeric width="100">
                    <div class="invoice-options-dropdown">
                        <b-button tag="router-link" type="is-dark" size="is-small" :to="{ name: 'ContractsRecordView', params: {id: props.row.id} }">Bekijken</b-button>
                        <b-dropdown :triggers="['hover']" aria-role="list" position="is-bottom-left" class="is-inline-block">
                            <template #trigger>
                                <b-button
                                    type="is-dark"
                                    size="is-small"
                                    icon-right="chevron-down" />
                            </template>

                            <b-dropdown-item aria-role="listitem" v-if="hideEndingContract || props.row.finalized == 1" disabled>Contract beëindigen</b-dropdown-item>
                            <router-link v-else class="dropdown-item" aria-role="listitem" has-link :to="{ name: 'ContractsRecordView', params: {id: props.row.id}, query: {cancel: true} }">Contract beëindigen</router-link>

                            <b-dropdown-item aria-role="listitem" v-if="props.row.finalized == 1" disabled>Prijswijziging aanmaken</b-dropdown-item>
                            <router-link v-else class="dropdown-item" aria-role="listitem" has-link :to="{ name: 'ContractsPriceChangesRecord', params: {id: 'nieuw'}, query: {'contract': props.row.id} }">Prijswijziging aanmaken</router-link>

                            <b-dropdown-item aria-role="listitem" v-if="showEscalation" @click="$refs['InvoiceEscalateModals'].toggleEscalateModal({esc_contract: props.row.id})">{{ escalationName == 'escalatie' ? 'Escaleren' : 'Deurwaarder' }}</b-dropdown-item>
                        </b-dropdown>
                    </div>
                </b-table-column>
            </template>

            <template #empty>
                <section class="section">
                    <div class="content has-text-grey has-text-centered">
                        <p class="margin0" v-if="loading === false">Geen contracten gevonden.</p>
                        <p class="margin0" v-else>Laden...</p>
                    </div>
                </section>
            </template>
        </b-table>
    </div>
</template>


<script>
import filtersMixin from '@/mixins/filterMixins'
import paramsMixin from '@/mixins/paramsMixin'
import escalationMixin from '@/mixins/escalationMixin.js'
import InvoiceEscalateModals from '@/vue/invoices/components/InvoiceEscalateModals'

export default {
    name: 'ContractsOverviewTable',
    mixins: [filtersMixin, paramsMixin, escalationMixin],

    props: {
        passParams: {
            type: Object,
            default: () => ({})
        }
    },

    components: {
        InvoiceEscalateModals
    },

    props: {
        getFilters: {
            type: Object,
            required: false,
            default: () => ({})
        }
    },

    data () {
        return {
            records: [],

            total: null,
            loading: false,
            sortField: 'created_at',
            sortOrder: 'desc',
            defaultSortOrder: 'desc',
            page: 1,
            perPage: 35,
            searchParams: typeof(this.$store.state.searchQueries['ContractsOverview']) != 'undefined' ? this.$store.state.searchQueries['ContractsOverview'] : null
        }
    },

    computed: {
        paginated(){
            return this.records.length < this.total
        },
        user() {
            return this.$store.state.user
        },
        organisations() {
            return this.$store.state.organisations ? this.$store.state.organisations : null
        },
        hideSensitiveData() {
            return this.$store.state.hideSensitiveData
        },
        hideEndingContract() {
            let hideEndingContract = false

            if(_.has(this.user.organisation_settings, 'strictcontracts') && this.user.organisation_settings.strictcontracts == 1 && (this.user.role != 'pit' && !this.user.is_admin)){
                hideEndingContract = true
            }

            return hideEndingContract
        },

        // Moved to mixin!
        // showEscalation() {
        //     let escalationPossible = false

        //     if((this.user.role == 'pit' || (this.user.is_admin && _.has(this.user.organisation_settings, 'escalation') && this.user.organisation_settings.escalation == 1)) ){
        //         escalationPossible = true
        //     }

        //     // This option is not valid, you can always escalate but sending to deurwaarder is prompted.
        //     if(_.has(this.user.organisation_settings, 'escalation') && this.user.organisation_settings.escalation == 1){
        //         if(!this.user.is_admin && (_.has(this.user.organisation_settings, 'escalation_admin') && this.user.organisation_settings.escalation_admin == 1)){
        //             escalationPossible = false
        //         } else {
        //             escalationPossible = true
        //         }
        //     }

        //     // Overrule for PIT admins
        //     if(this.user.role == 'pit'){
        //         escalationPossible = true
        //     }

        //     return escalationPossible
        // },
        // showOutEscalation() {
        //     let escalationPossible = false

        //     if((_.has(this.user.organisation_settings, 'escalation') && this.user.organisation_settings.escalation == 1) && (_.has(this.user.organisation_settings, 'escalation_out') && this.user.organisation_settings.escalation_out == 1)){
        //         // no admin and rights not possible
        //         if(!this.user.is_admin && (!_.has(this.user.organisation_settings, 'escalation_out_admin') || this.user.organisation_settings.escalation_out_admin == 1)){
        //             escalationPossible = false
        //         }
        //         if(!this.user.is_admin && (!_.has(this.user.organisation_settings, 'escalation_out_admin') || this.user.organisation_settings.escalation_out_admin == false)){
        //             escalationPossible = true
        //         }

        //         // admin and rights possible
        //         if(this.user.is_admin){
        //             escalationPossible = true
        //         }
        //     }

        //     return escalationPossible
        // },
        // escalationName() {
        //     return _.has(this.user, 'organisation_settings.escalation_name') ? this.user.organisation_settings.escalation_name : 'escalatie'
        // }
    },

    // created() {
    //     console.log('Created')
    // },

    methods: {
        loadAsyncData(passParams) {
            let paramsWithFilters = ''

            // Add customer filter if provided
            if (this.getFilters && this.getFilters.customer) {
                // Construct params specifically for the customer view, ignoring stored searchParams
                paramsWithFilters = `page=${this.page}&sort_by=${this.sortField}.${this.sortOrder}&per_page=${this.perPage}&customer=${this.getFilters.customer}`
            } else {
                // Use existing logic with setParams for the general overview table
                let params = this.setParams(this.searchParams, 'ContractsOverview')
                paramsWithFilters = params

                // Add confirmstops filter if present in route query (keep this for general overview)
                if (this.$route.query.confirmstops === '1') {
                    paramsWithFilters += '&confirmstops=1'
                }
            }


            // Add any additional passed parameters
            if (passParams) {
                paramsWithFilters += `&${passParams}`
            }

            this.loading = true
            this.$emit('passLoading', true)

            axios.get(`/api/contracts?${paramsWithFilters}`, {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then((response) => {
                this.records = []

                this.total = response.data.total
                this.page = response.data.current_page
                this.records = response.data.data

                // Only store search query if not filtered by a specific customer
                if (!(this.getFilters && this.getFilters.customer)) {
                    this.$store.dispatch('setSearchQuery', {type: 'ContractsOverview', query: paramsWithFilters.split('&').filter(p => !p.startsWith('page=')).join('&')}) // Store params without page number
                }
            }).catch((error) => {
                console.error('[❌] Error while fetching contracts:', error)
                // this.data = []
                // this.total = 0
            }).then(() => {
                this.loading = false
                // Reset searchParams only when not filtering by customer to avoid clearing filters unintentionally
                if (!(this.getFilters && this.getFilters.customer)) {
                    this.searchParams = null
                }

                this.$emit('passTotal', this.total)
                this.$emit('passLoading', false)
            })
        },

        loadContractsFromBox(id){
            if(!id){ console.error('No ID supplied!!'); return false }

            axios.get('/api/boxes/'+this.$route.params.id+'/contracts', {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then((response) => {
                this.records = []

                this.total = response.data.total
                this.page = response.data.current_page
                this.records = response.data.data

                this.$emit('giveAmountOfContracts', response.data.total)
            }).catch((error) => {
                console.error('[❌] Error while fetching contracts for box:', error)
            }).then(() => {
                this.loading = false
                this.$emit('passLoading', false)
            })
        },

        onPageChange(page) {
            this.page = page
            this.loadAsyncData()
        },

        onSort(field, order) {
            this.sortField = field
            this.sortOrder = order
            this.loadAsyncData()
        }
    }
}
</script>